<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="ORIM-Book-Title">Mornings in London</p>
<p class="ORIM-Book-Subtitle">A Francis Bacon Mystery</p>
<p class="ORIM-Author-Name"><span class="CharOverride-1">JANICE LAW</span></p>
<p class="ORIM-Author-Name _idGenParaOverride-1"><img src="image/logo3.jpg"/></p>
<p class="ORIM-Dedication">To Jerry, Jamie, and Shanna</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled1.vue?203117fe